import type { ComponentType } from 'react'
import type { ModoVisualizacao } from '../../visualizacao3d/componentes/contextoMaquete'
import { IconeModuloTabletop, type PropsIcone } from '../icones'

/**
 * Os módulos do laboratório, numa tabela só.
 *
 * Acrescentar um módulo é acrescentar uma linha aqui, um id em `IdModulo` e o
 * manifesto de ferramentas em `apresentacao/modulos/`. Os próximos previstos são
 * o trabalho em altura e o corte de árvore (ver `docs/PLANO-SALVAMENTO-TERRESTRE.md`).
 */

export type IdModulo = 'tabletop'

export interface Modulo {
  id: IdModulo
  /** Nome curto, usado na navegação. */
  rotulo: string
  /** Nome completo, usado em títulos e rótulos acessíveis. */
  titulo: string
  /** Preset de visualização 3D que o módulo assume ao ser aberto. */
  modo: ModoVisualizacao
  Icone: ComponentType<PropsIcone>
}

export const MODULOS: readonly Modulo[] = [
  {
    id: 'tabletop',
    rotulo: 'Table top',
    titulo: 'Table top de salvamento',
    modo: 'tabletop',
    Icone: IconeModuloTabletop,
  },
]

export function moduloPorId(id: IdModulo): Modulo {
  const achado = MODULOS.find((modulo) => modulo.id === id)
  if (!achado) throw new Error(`Módulo desconhecido: ${id}`)
  return achado
}
